/** Normalize Nest / validation error bodies into a single user-facing string. */
export function formatApiErrorMessage(body: unknown, fallback: string): string {
  if (typeof body === 'string' && body.trim()) return body.trim();
  if (!body || typeof body !== 'object') return fallback;
  const o = body as Record<string, unknown>;
  const msg = o.message;
  if (typeof msg === 'string' && msg.trim()) return msg.trim();
  if (Array.isArray(msg)) {
    const parts = msg
      .map((m) => (typeof m === 'string' ? m : typeof m === 'object' && m && 'message' in m ? String((m as { message: unknown }).message) : ''))
      .filter(Boolean);
    if (parts.length) return parts.join('. ');
  }
  if (typeof o.error === 'string' && o.error.trim()) return o.error.trim();
  return fallback;
}

export function isEmailNotVerifiedError(status: number, body: unknown): boolean {
  if (status !== 401 && status !== 403) return false;
  const text = formatApiErrorMessage(body, '').toLowerCase();
  return (
    text.includes('verify') ||
    text.includes('verification') ||
    text.includes('not verified') ||
    text.includes('unverified')
  );
}
